// extracted by mini-css-extract-plugin
module.exports = {"awards":"styles_awards__p1VZT","pulse":"styles_pulse__6QfYo","jump":"styles_jump__SWDuV"};